import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";
import { createTag } from "./api";
import { invalidateAllQueries } from "utils/utils";

function buildPayload(values) {
  if (!values || typeof values !== "object") return {};
  console.log(values);
  return {
    ...Object.fromEntries(
      Object.entries(values).filter(
        ([_, v]) => v !== "" && v !== undefined && v !== null
      )
    ),
  };
}

export function useCreateTag() {
  return useMutation({
    mutationFn: async ({ item }) => {
      const payload = buildPayload(item);
      const response = await createTag({ item: payload });
      return response;
    },
    onSuccess: () => {
      toast.success("Tag Created Successfully");
      invalidateAllQueries();
    },
    onError: (error) => {
      toast.error(error.message);
      console.log(error.message);
    },
  });
}
